import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import { useForm } from "react-hook-form";
import MyInput from "../../MyComponents/Form/MyInput";
import { Badge, Form } from "reactstrap";
import MyButton from "../../MyComponents/Form/MyButton";
import { toast } from "react-toastify";
import MyDataTable from "../../MyComponents/Table/MyDataTable";
import ConfirmModal from "../../MyComponents/Modal/ConfirmModal";
import useLogout from "../../Hooks/Logout";
import { decrypt, formatDateTimeIST, getToastMetaFromApiResponse, hasAdminPermission } from "../../utils/Utils";
import { useNavigate } from "react-router";
import {
  createDepartmentAPI,
  getDepartmentListAPI,
  updateDepartmentAPI,
  updateDepartmentStatusAPI,
} from "../../api/department";

const Department = () => {
  const canView = hasAdminPermission("department.view");
  const canCreate = hasAdminPermission("department.create");
  const canUpdate = hasAdminPermission("department.update");
  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [mode, setMode] = useState("Add");
  const [data, setData] = useState([]);

  const logout = useLogout();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm();

  const [columns, setColumns] = useState([
    {
      name: "Name",
      selector: (row) => row?.name,
      sortable: true,
    },
    {
      name: "Created At (IST)",
      selector: (row) => formatDateTimeIST(row?.created_at),
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => (row?.status === 1 ? "Active" : "InActive"),
      cell: (row) => (
        <div style={{ cursor: canUpdate ? "pointer" : "default" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={row.status === 1 ? "success" : "danger"}>{row.status === 1 ? "Active" : "InActive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },

    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <div>
          {canUpdate ? (
            <Button outline color={`warning`} size={`xs`} className={`me-1`} onClick={() => handleEdit(row)}>
              <Icon name="edit" />
            </Button>
          ) : (
            <span className="text-soft small">—</span>
          )}
        </div>
      ),
    },
  ]);
  useEffect(() => {
    getDepartment();
  }, []);

  const getDepartment = (data) => {
    setIsLoading(true);
    getDepartmentListAPI(data)
      .then((res) => {
        const status = res.data.status;
        if (status === true) {
          const decryptedResponse = res.data.data;
          setData(decryptedResponse);
          toast.clearWaitingQueue();
          setIsLoading(false);
        } else if (status === false) {
          const { kind, message } = getToastMetaFromApiResponse(res);
          toast[kind]?.(message);
          toast.clearWaitingQueue();
          setData([]);
          setIsLoading(false);
        } else if (status === "expired") {
          const { message } = getToastMetaFromApiResponse(res);
          toast.error(message);
          logout();
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.error(err);
      });
  };
  const handleToggleStatus = (row) => {
    if (!canUpdate) return;
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const handleEdit = (row) => {
    if (!canUpdate) return;
    console.log(row, "aaaaaaa");
    setValue("selectedRow", row);
    setValue("name", row?.name);
    setIsOpen(true);
    setMode("Edit");
  };

  const onFormSubmit = (data) => {
    const body = {
      name: watch("name"),
      ...(mode == "Edit" && { department_id: watch("selectedRow")?.id }),
    };
    if (mode == "Add") {
      createDepartmentAPI(body)
        .then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            console.log();
            getDepartment();
            reset();
            setIsOpen(false);
            setValue("isLoading", false);
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err.message);
        });
    }
    if (mode == "Edit") {
      updateDepartmentAPI(body)
        .then((res) => {
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getDepartment();
            reset();
            setIsOpen(false);
            setValue("isLoading", false);
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err.message);
        });
    }
  };

  const confirmStatusChange = (newStatus) => {
    const departmentId = watch("selectedRow").id;
    const formObject = {
      department_id: departmentId,
      status: newStatus,
    };

    updateDepartmentStatusAPI(formObject)
      .then((res) => {
        console.log(res, "res");
        const status = res.data.status;
        console.log(status, "statussdfsf");

        if (status === true) {
          getDepartment();
          toast.success(res.data.message);
        } else if (status === false) {
          toast.error(res.data.message);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }

        setShowModal(false);
      })
      .catch((err) => {
        console.error("Error updating status:", err);
        toast.error("Something went wrong. Please try again.");
      });
  };

  return (
    <>
      <Head title={"Department"} />
      <Content>
        {!canView ? (
          <BlockHead size={`sm`}>
            <BlockBetween>
              <BlockHeadContent>
                <BlockTitle page tag="h3">
                  Manage Department
                </BlockTitle>
                <p className="text-soft small mb-0">
                  Permission denied: <code>department.view</code>
                </p>
              </BlockHeadContent>
            </BlockBetween>
          </BlockHead>
        ) : null}
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Department"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                {canCreate ? (
                  <Button
                    color="primary"
                    outline
                    className={`  me-n1`}
                    onClick={() => {
                      setIsOpen((pre) => !pre);
                      setMode("Add");
                      reset();
                    }}
                  >
                    <Icon name={isOpen ? "minus" : "plus"} />
                  </Button>
                ) : null}
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <>
            {isOpen && (
              <>
                {" "}
                <PreviewAltCard>
                  <Form onSubmit={handleSubmit(onFormSubmit)}>
                    <Row>
                      <Col md="6" className={``}>
                        <MyInput
                          register={register}
                          watch={watch}
                          setValue={setValue}
                          trigger={trigger}
                          errors={errors}
                          title={"Name"}
                          name={"name"}
                          placeholder={"Enter name"}
                          required
                          min={2}
                          max={50}
                          inputPattern={/[^A-Za-z\s]/g}
                          pattern={/^(?!\s*$)[a-zA-Z /.]*$/}
                          patternMsg={"Only alphabets are allowed"}
                        />
                      </Col>
                      <MyButton isLoading={isLoading} mode={mode} />
                    </Row>
                  </Form>
                </PreviewAltCard>
              </>
            )}
          </>
          <MyDataTable data={data} columns={columns} title={"Department"} isLoading={isLoading} />
        </Block>
      </Content>
      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
      />
    </>
  );
};

export default Department;
